<div class="cash-dialog">
  <div class="dialog-header">
    <div class="header-title">
      <mat-icon class="header-icon">inventory_2</mat-icon>
      <div>
        <h2 mat-dialog-title class="title-text">Inventaire du coffre-fort</h2>
        <span class="subtitle-text">Le montant compté devient le point de départ du solde du coffre</span>
      </div>
    </div>
    <button mat-icon-button type="button" (click)="close()" [disabled]="sending" aria-label="Fermer" class="btn-close">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-dialog-content class="dialog-content">
    <!-- Après l'inventaire, seul le résultat du serveur reste à l'écran : l'ancien solde le contredirait. -->
    @if (!done) {
      <div class="count-layout">
        <section class="count-side">
          <div class="target">
            <mat-icon>lock</mat-icon>
            <b id="strongbox-count-strongbox">{{ strongboxName }}</b>
            <span class="target-balance">{{ storeName }}</span>
          </div>

          @if (loadError) {
            <div class="msg msg-error">
              <mat-icon>error_outline</mat-icon>
              <span>Lecture du solde du coffre impossible : {{ loadError }}</span>
            </div>
            <button mat-stroked-button type="button" class="btn-retry" (click)="loadBalance()">Réessayer</button>
          }

          @if (balance) {
            <table class="breakdown" id="strongbox-count-balance">
              <tbody>
                <tr>
                  @if (balance.opening_float_found) {
                    <td>Dernier inventaire @if (lastCount) { <span class="note">{{ lastCount }}</span> }</td>
                  } @else {
                    <td>Aucun inventaire <span class="note">(départ à 0)</span></td>
                  }
                  <td class="num">{{ balance.opening_float | fc }} €</td>
                </tr>
                @if (balance.cash_payments) {
                  <tr><td>+ Espèces encaissées</td><td class="num" [class.neg]="balance.cash_payments < 0">{{ balance.cash_payments | fc }} €</td></tr>
                }
                <tr><td>+ Reçu</td><td class="num">{{ balance.transfers_in | fc }} €</td></tr>
                <tr><td>− Sorti</td><td class="num">{{ balance.transfers_out | fc }} €</td></tr>
                <tr class="total"><td>Solde théorique actuel</td><td class="num" [class.neg]="balance.balance < 0">{{ balance.balance | fc }} €</td></tr>
              </tbody>
            </table>
          }

          @if (gap !== null) {
            <div class="count-gap" id="strongbox-count-gap" [class.neg]="gap < 0" [class.pos]="gap > 0">
              Écart : <span class="num">{{ signed(gap) }} €</span>
              @if (gap < 0) { <span class="note"> (manque)</span> } @else if (gap > 0) { <span class="note"> (excédent)</span> } @else { <span class="note"> (juste)</span> }
            </div>
          } @else if (balance) {
            <div class="note" id="strongbox-count-gap-hint">Comptez le coffre : l'écart avec le solde théorique s'affiche ici.</div>
          }
        </section>

        <!-- Grille ouverte d'emblée : chaque frappe remplit le montant compté. -->
        <section class="count-main">
          <div class="count-title">Comptage du coffre</div>
          <app-cash-count-grid idPrefix="strongbox-count" caption="Inventaire du coffre" [disabled]="sending || lost" (changed)="counted.onCount($event)" (lastEnter)="counted.focusNext()" />
          <form [formGroup]="form" (ngSubmit)="confirm()" id="strongboxCountForm">
            <mat-form-field appearance="outline" class="amount-field">
              <mat-label>Montant compté</mat-label>
              <input matInput appCents type="number" step="0.01" min="0" formControlName="amount" id="strongbox-count-amount" autocomplete="off" required (focus)="$any($event.target).select()" />
              <span matTextSuffix>&nbsp;€</span>
              @if (amount.hasError('amountCap')) {
                <mat-error>Au plus 999 999 999,99 €</mat-error>
              } @else if (amount.hasError('required')) {
                <mat-error>Comptez ou saisissez le contenu du coffre (0 s'il est vide)</mat-error>
              } @else if (amount.invalid) {
                <mat-error>Montant positif ou nul, deux décimales au plus</mat-error>
              }
            </mat-form-field>
          </form>
          @if (counted.differsNote) {
            <div class="note count-differs" id="strongbox-count-differs">{{ counted.differsNote }}</div>
          }
        </section>
      </div>
    }

    @if (sendError) {
      <!-- Pas « -error » : la grille (idPrefix strongbox-count) pose déjà cet id sur son alerte de saisie. -->
      <div class="msg msg-error" id="strongbox-count-refusal">
        <mat-icon>error_outline</mat-icon>
        <span>{{ lost ? '' : 'Inventaire refusé : ' }}{{ sendError }}</span>
      </div>
    }

    @if (done) {
      <div class="msg msg-ok" id="strongbox-count-done">
        <mat-icon>check_circle</mat-icon>
        <div>
          <div>{{ done.msg }}</div>
          <div>Nouveau point de départ du solde de {{ done.count.station_name ?? strongboxName }} : <b>{{ done.count.amount | fc }} €</b></div>
        </div>
      </div>
    }
  </mat-dialog-content>

  <mat-dialog-actions align="end" class="dialog-actions">
    @if (done) {
      <button mat-flat-button color="primary" type="button" (click)="close()" id="strongbox-count-close">Fermer</button>
    } @else {
      <button mat-button type="button" (click)="close()" [disabled]="sending">{{ lost ? 'Fermer' : 'Annuler' }}</button>
      <button mat-flat-button color="primary" type="submit" form="strongboxCountForm" [disabled]="!canConfirm" class="btn-submit" id="strongbox-count-submit">
        <mat-icon>inventory_2</mat-icon>
        <span>Enregistrer l'inventaire</span>
      </button>
    }
  </mat-dialog-actions>
</div>
